import {
    MASK_TXT_DEFAULT_MAP,
    ONE_LEVEL_TITLE_DEFAULT_MAP,
    TWO_LEVEL_TITLE_DEFAULT_MAP,
    MASK_TXT_FONT_SIZE_MAP,
    ONE_LEVEL_TITLE_FONT_SIZE_MAP,
    TWO_LEVEL_TITLE_FONT_SIZE_MAP,
    MASK_TXT_FONT_FAMILY_MAP,
    ONE_LEVEL_TITLE_FONT_FAMILY_MAP,
    TWO_LEVEL_TITLE_FONT_FAMILY_MAP,
    MASK_TXT_COLOR_MAP,
    ONE_LEVEL_TITLE_COLOR_MAP,
    TWO_LEVEL_TITLE_COLOR_MAP,
    MASK_TXT_LINE_HEIGHT_MAP,
    ONE_LEVEL_TITLE_LINE_HEIGHT_MAP,
    TWO_LEVEL_TITLE_LINE_HEIGHT_MAP
} from '../constants/index';

/**
 * 判断是否为编辑器
 * @returns
 */
function isEditor() {
    return !!window.FEGOEditor;
}

/**
 * 判断H5还是Web模式
 * @returns
 */
function isPcMode() {
    const isEditorMode = isEditor();
    if (isEditorMode) {
        return parseInt(FEGOEditor.app.project.route.now.pageType, 2) === 2;
    } else {
        return parseInt(FEGORender.store.route.now.pageType, 2) === 2;
    }
}

/**
 * 判断是否HK地区向你们
 * @returns
 */
function isHKProject() {
    const isEditorMode = isEditor();
    if (isEditorMode) {
        const { list, current: curCode } = window.top.area;
        const curArea = list.find((item) => item.code === curCode);
        return curArea && curArea.siteLocationId === 6;
    }
}

/**
 * 获取当前的页面语言情况
 * @returns
 */
function getNowLang() {
    const isEditorMode = isEditor();
    if (isEditorMode) {
        return FEGOEditor.app.project.route.now.lang;
    } else {
        return FEGORender.store.route.now.lang;
    }
}

/**
 * 返回默认的H5遮罩文案
 * @returns
 */
function getDefaultMaskTxt() {
    const lang = getNowLang();
    const lineHeight = MASK_TXT_LINE_HEIGHT_MAP[lang];
    const fontSize = MASK_TXT_FONT_SIZE_MAP[lang];
    const fontFamily = MASK_TXT_FONT_FAMILY_MAP[lang];
    const color = MASK_TXT_COLOR_MAP[lang];
    const defaultText = MASK_TXT_DEFAULT_MAP[lang];
    return `<p style="line-height:${lineHeight}"><span style="font-size:${fontSize};font-family:${fontFamily};color:${color};">${defaultText}</span></p>`;
}
/**
 * 返回默认的WEB遮罩一级文案
 * @returns
 */
function getDefaultOneLevelTxt() {
    const lang = getNowLang();
    const lineHeight = ONE_LEVEL_TITLE_LINE_HEIGHT_MAP[lang];
    const fontSize = ONE_LEVEL_TITLE_FONT_SIZE_MAP[lang];
    const fontFamily = ONE_LEVEL_TITLE_FONT_FAMILY_MAP[lang];
    const color = ONE_LEVEL_TITLE_COLOR_MAP[lang];
    const defaultText = ONE_LEVEL_TITLE_DEFAULT_MAP[lang];
    return `<p style="line-height:${lineHeight}"><span style="font-size:${fontSize};font-family:${fontFamily};color:${color};">${defaultText}</span></p>`;
}
/**
 * 返回默认的WEB遮罩二级文案
 * @returns
 */
function getDefaultTwoLevelTxt() {
    const lang = getNowLang();
    const lineHeight = TWO_LEVEL_TITLE_LINE_HEIGHT_MAP[lang];
    const fontSize = TWO_LEVEL_TITLE_FONT_SIZE_MAP[lang];
    const fontFamily = TWO_LEVEL_TITLE_FONT_FAMILY_MAP[lang];
    const color = TWO_LEVEL_TITLE_COLOR_MAP[lang];
    const defaultText = TWO_LEVEL_TITLE_DEFAULT_MAP[lang];
    return `<p style="line-height:${lineHeight}"><span style="font-size:${fontSize};font-family:${fontFamily};color:${color};">${defaultText}</span></p>`;
}

const $message =  window.FEGOEditor && window.FEGOEditor.app.stage && window.FEGOEditor.app.stage.$message;

export {
    $message,
    isEditor,
    isHKProject,
    isPcMode,
    getNowLang,
    getDefaultMaskTxt,
    getDefaultOneLevelTxt,
    getDefaultTwoLevelTxt,
};
